<script setup lang="ts">
import { computed } from 'vue'
import Loading from 'vue-loading-overlay'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'
import NavBar from '@/components/NavBar.vue'
import CookieBanner from '@/components/CookieBanner.vue'
import SessionExpiredModal from '@/components/SessionExpiredModal.vue'

const authStore = useAuthStore()
const appStore = useAppStore()
const signedIn = computed(() => authStore.isSignedIn)
const isLoading = computed(() => appStore.isLoading())
</script>

<template>
  <div id="app">
    <NavBar v-if="signedIn" />
    <RouterView />
    <CookieBanner v-if="signedIn" />
    <SessionExpiredModal v-if="signedIn" />
    <Loading
      :active="isLoading"
      color="#ffd200"
      background-color="rgba(0,0,0,.4)"
      :opacity="1"
      :width="80"
      :height="80"
      loader="dots"
      :z-index="99999"
    />
  </div>
</template>
